<template>
  <div class="d-flex justify-center">
    <div
      class="profitability-toggle-switch"
      :class="{'disabled': disabled}"
    >
      <span
        :class="['toggle-label', {'active-label': !value, 'disabled': disabled}]"
        @click="handleLabelClick(false)"
      >
        {{ disabledLabel }}
      </span>
      <div
        :class="['toggle-track', {'inactive': !value, 'disabled': disabled}]"
        @click="handleTrackClick"
      >
        <div
          :class="['toggle-thumb', {'active': value, 'disabled': disabled}]"
        />
      </div>
      <span
        :class="['toggle-label', {'active-label': value, 'disabled': disabled}]"
        @click="handleLabelClick(true)"
      >
        {{ enabledLabel }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name : 'BankingSwitch',
  props: {
    value: {
      type   : Boolean,
      default: false
    },
    enabledLabel: {
      type    : String,
      required: true
    },
    disabledLabel: {
      type    : String,
      required: true
    },
    disabled: {
      type   : Boolean,
      default: false
    }
  },
  methods: {
    toggleValue () {
      if (!this.disabled) {
        this.$emit('input', !this.value)
      }
    },
    updateValue (value) {
      if (!this.disabled) {
        this.$emit('input', value)
      }
    },
    handleLabelClick (value) {
      if (!this.disabled) {
        this.$emit('input', value)
      }
    },
    handleTrackClick () {
      if (!this.disabled) {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>
<style scoped>
.profitability-toggle-switch {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.profitability-toggle-switch.disabled {
  cursor: not-allowed;
}

.toggle-label {
  font-size: 10px;
  font-weight: 400;
  color: #666;
  transition: color 0.3s ease;
  cursor: pointer;
  user-select: none;
}

.toggle-label.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.toggle-track {
  position: relative;
  width: 40px;
  min-width: 40px;
  height: 20px;
  background-color: #1976D2;
  border-radius: 100px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.toggle-track.disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.toggle-track.inactive.disabled {
  background-color: #e0e0e0;
}

.toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-thumb.active {
  transform: translateX(20px);
}

.toggle-thumb.disabled {
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.toggle-label.active-label {
  font-weight: 700;
  color: #333;
}

</style>
